module.exports = __webpack_public_path__ + "8bacebef3a818078941206f86b137274.png";